import React, { useState } from "react";
import styled from "styled-components";
import { filterDigitsAndHyphen, toNumber } from "../../types/types";

const Wrapper = styled.div<{
  width?: string;
  $isLast?: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.6vw;
  width: ${(props) => (props.width ? props.width : "100%")};
  height: 100%;
  border-top: 0.1vw solid #606060;
  border-right: 0.1vw solid #606060;
  border-bottom: ${(props) => (props.$isLast ? "0.1vw solid #606060;" : "")};
  position: relative;
`;

const SelectionBox = styled.div<{
  $isFocused?: boolean;
  readOnly?: boolean;
}>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  outline-offset: -0.2vw;
  outline: ${(props) =>
    props.$isFocused
      ? "0.3vw solid #FF7F3B"
      : "none"}; /* 포커스 시 보더 표시 */
  pointer-events: none; /* SelectionBox가 클릭되지 않도록 설정 */
`;

const SelectionBox2 = styled.div<{
  $isFocused?: boolean;
  readOnly?: boolean;
}>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  /* outline-offset: -0.2vw;
  outline: ${(props) =>
    props.$isFocused ? "0.3vw solid #575757" : "none"};  */
  /* 포커스 시 보더 표시 */
  pointer-events: none; /* SelectionBox가 클릭되지 않도록 설정 */
`;

const InputBox = styled.div<{
  $type?: string;
  $textAlign?: string;
}>`
  display: flex;
  justify-content: end;
  align-items: center;
  border: none;
  width: 100%;
  height: 100%;
  font-size: 1.4vw;
  font-weight: 400;
  padding-right: 1vw;
  /* text-align: end; */
  &:focus {
    outline: none; /* 포커스 스타일 제거 */
  }

  // 기본 스핀 버튼 숨기기
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  &[type="number"] {
    -moz-appearance: textfield;
  }
`;

export default function TableItemExport(props: any) {
  const {
    value,
    type,
    textAlign,
    setData,
    name,
    currentPage,
    idx,
    width,
    readOnly,
  } = props;

  const [isFocused, setIsFocused] = useState(false);

  const onChangeInput = (e: any) => {
    let inputValue = e.target.value;

    if (type === "number") {
      inputValue = filterDigitsAndHyphen(inputValue);
      setData((prev: any) => {
        const updatedData = { ...prev };
        const paths = name.split(".");
        const charge =
          updatedData.chargeList[currentPage - 1][paths[1]][paths[2]][idx];

        charge[paths[3]] = inputValue.toLocaleString(); // 값 업데이트

        // 'quantity' 또는 'unitPrice'에 대한 추가 계산
        if (paths[3] === "quantity") {
          charge.amount = (
            toNumber(inputValue) * toNumber(charge.unitPrice)
          ).toLocaleString();
        } else if (paths[3] === "unitPrice") {
          charge.amount = (
            toNumber(charge.quantity) * toNumber(inputValue)
          ).toLocaleString();
        }

        return updatedData;
      });
    } else if (type === "string") {
      setData((prev: any) => {
        const updatedData = { ...prev };
        const paths = name.split(".");
        updatedData.chargeList[currentPage - 1][paths[1]][paths[2]][idx][
          paths[3]
        ] = inputValue;
        return updatedData;
      });
    }
  };

  return (
    <Wrapper width={width}>
      {readOnly ? (
        <>
          <InputBox>
            {value === "" ? (
              ""
            ) : (
              <>{type === "string" ? Number(value).toLocaleString() : value}</>
            )}
          </InputBox>
          <SelectionBox2 $isFocused={isFocused}></SelectionBox2>
        </>
      ) : (
        <>
          <InputBox>{value}</InputBox>
          <SelectionBox $isFocused={isFocused}></SelectionBox>
        </>
      )}
    </Wrapper>
  );
}
